<template>
  <div class="tags-view">
    <div class="tags-view-container">
      <div
        class="tags-view-item"
        v-for="tag in visitedViews"
        :key="tag.tagId"
        :class="isActive(tag) ? 'active' : ''"
        @click="openTag(tag)"
        @contextmenu.prevent="openMenu(tag, $event)"
      >
        <span class="tag-title">{{ tag.title }}</span>
        <span
          v-if="!isAffix(tag)"
          class="el-icon-close"
          @click.stop.prevent="closeTag(tag)"
        ></span>
      </div>
    </div>

    <ul
      v-show="visible"
      class="contextmenu"
      :style="{ left: left + 'px', top: top + 'px' }"
    >
      <li @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags(selectedTag)">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      visitedViews: [],
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      routes: []
    }
  },
  computed: {
    currentRoute() {
      return this.$route
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.addViewToTags(route)
      }
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    getTagId(route) {
      if (route.name === 'orderDetail' && route.query && route.query.id != null && String(route.query.id) !== '') {
        return `orderDetail:${String(route.query.id)}`
      }
      if (route.name === 'createWorkOrder' && route.query && route.query.id != null && String(route.query.id) !== '') {
        return `createWorkOrder:${String(route.query.id)}`
      }
      if (route.name === 'addOrder' && route.query && route.query.id != null && String(route.query.id) !== '') {
        return `addOrder:${String(route.query.id)}`
      }
      if (route.name === 'addOrder') {
        return '/oms/addOrder'
      }
      if (route.path === '/home' || route.name === 'home') return '/home'
      if (route.name === 'order' || route.path === '/oms/order') return '/oms/order'
      if (route.name === 'hotel' || route.path === '/hms/hotel') return '/hms/hotel'
      if (route.name === 'hotelDetail' && route.params && route.params.id != null && String(route.params.id) !== '') {
        return `hotelDetail:${String(route.params.id)}`
      }
      return route.fullPath
    },
    resolveTagTitle(route) {
      if (route.name === 'orderDetail') {
        const no = route.query.orderNo || route.query.order_number
        if (no) return `订单详情_${no}`
        return (route.meta && route.meta.title) || '订单详情'
      }
      if (route.name === 'createWorkOrder') {
        const no = route.query.orderNo || route.query.order_number
        if (no) return `创建工单_${no}`
        return (route.meta && route.meta.title) || '创建工单'
      }
      if (route.name === 'addOrder' && route.query && route.query.id != null && String(route.query.id) !== '') {
        return '编辑订单'
      }
      if (route.name === 'addOrder') {
        return '添加订单'
      }
      if (route.name === 'hotelDetail') {
        const name = route.query.hotelName || route.query.hotel_name
        if (name) return name
        const id = route.params && route.params.id
        if (id != null && String(id) !== '') return String(id)
        return '酒店'
      }
      const last = route.matched.filter(r => r.meta && r.meta.title).pop()
      return (last && last.meta && last.meta.title) || (route.meta && route.meta.title) || '未命名'
    },
    isActive(tag) {
      return tag.tagId === this.getTagId(this.currentRoute)
    },
    isAffix(tag) {
      // 首页不显示关闭按钮
      return tag.tagId === '/home'
    },
    addViewToTags(route) {
      // 如果是登录页或404页，不添加到标签页
      if (route.path === '/login' || route.path === '/404' || route.path === '*') {
        return
      }

      // 确保首页总是第一个标签
      const hasHome = this.visitedViews.some(view => view.tagId === '/home')
      if (!hasHome) {
        this.visitedViews.push({
          tagId: '/home',
          path: '/home',
          name: 'home',
          title: '首页',
          fullPath: '/home'
        })
      }

      const matched = route.matched.filter(item => item.meta && item.meta.title)
      if (matched.length === 0) return

      const tagId = this.getTagId(route)
      const routeInfo = {
        tagId,
        path: route.path,
        name: route.name,
        title: this.resolveTagTitle(route),
        fullPath: route.fullPath
      }

      const existIndex = this.visitedViews.findIndex(view => view.tagId === tagId)
      if (existIndex >= 0) {
        const prev = this.visitedViews[existIndex]
        this.visitedViews.splice(existIndex, 1, {
          ...prev,
          ...routeInfo
        })
        return
      }

      if (route.name === 'orderDetail') {
        const orderListIndex = this.visitedViews.findIndex(
          v => v.tagId === '/oms/order' || v.name === 'order'
        )
        if (orderListIndex >= 0) {
          let insertAt = orderListIndex + 1
          while (
            insertAt < this.visitedViews.length &&
            this.visitedViews[insertAt].name === 'orderDetail'
          ) {
            insertAt += 1
          }
          this.visitedViews.splice(insertAt, 0, routeInfo)
          return
        }
      }

      if (route.name === 'createWorkOrder') {
        const orderListIndex = this.visitedViews.findIndex(
          v => v.tagId === '/oms/order' || v.name === 'order'
        )
        if (orderListIndex >= 0) {
          let insertAt = orderListIndex + 1
          while (
            insertAt < this.visitedViews.length &&
            (this.visitedViews[insertAt].name === 'orderDetail' ||
              this.visitedViews[insertAt].name === 'createWorkOrder')
          ) {
            insertAt += 1
          }
          this.visitedViews.splice(insertAt, 0, routeInfo)
          return
        }
      }

      if (route.name === 'hotelDetail') {
        const hotelListIndex = this.visitedViews.findIndex(
          v => v.tagId === '/hms/hotel' || v.name === 'hotel'
        )
        if (hotelListIndex >= 0) {
          let insertAt = hotelListIndex + 1
          while (
            insertAt < this.visitedViews.length &&
            this.visitedViews[insertAt].name === 'hotelDetail'
          ) {
            insertAt += 1
          }
          this.visitedViews.splice(insertAt, 0, routeInfo)
          return
        }
      }

      this.visitedViews.push(routeInfo)
    },
    closeTag(tag) {
      const index = this.visitedViews.findIndex(view => view.tagId === tag.tagId)
      if (index < 0) return
      this.visitedViews.splice(index, 1)

      // 如果关闭的是当前标签，则跳转到前一个标签
      if (this.getTagId(this.currentRoute) === tag.tagId) {
        const prevTag = this.visitedViews[index - 1] || this.visitedViews[index]
        if (prevTag) {
          this.$router.push(prevTag.fullPath || prevTag.path)
        }
      }
    },
    openTag(tag) {
      const dest = tag.fullPath || tag.path
      if (dest !== this.currentRoute.fullPath) {
        this.$router.push(dest)
      }
    },
    closeSelectedTag(selectedTag) {
      this.closeTag(selectedTag)
      this.closeMenu()
    },
    closeOthersTags(view) {
      this.visitedViews = this.visitedViews.filter(v => {
        return this.isAffix(v) || v.tagId === view.tagId
      })
      this.closeMenu()
    },
    closeAllTags(view) {
      this.visitedViews = this.visitedViews.filter(tag => this.isAffix(tag))
      this.$router.push('/home')
      this.closeMenu()
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = e.clientX - offsetLeft

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/styles/variables.scss";

.tags-view {
  width: 100%;
  height: 34px;
  background: $tagsBg;
  border-bottom: 1px solid $tagsBorder;
  box-shadow: 0 12px 18px rgba(84, 63, 32, 0.05);
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d6c1a1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f4ecdd;
  }

  .tags-view-container {
    display: inline-block;
    padding: 0 10px;
    height: 100%;
  }

  .tags-view-item {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 26px;
    line-height: 26px;
    border: 1px solid $tagsBorder;
    color: $tagsText;
    background: rgba(255, 255, 255, 0.72);
    padding: 0 8px;
    font-size: 12px;
    margin: 4px 2px 0 2px;
    border-radius: 999px;
    transition: all .3s;

    &:first-of-type {
      margin-left: 0;
    }

    &.active {
      background-color: $tagsActiveBg;
      color: $tagsActiveText;
      border-color: $tagsActiveBg;
      box-shadow: 0 8px 18px rgba(216, 155, 43, 0.24);

      &::before {
        content: '';
        background: rgba(43, 47, 54, 0.85);
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: relative;
        margin-right: 4px;
        vertical-align: middle;
      }
    }

    &:hover {
      border-color: $tagsHoverBorder;
      color: $navbarAccent;
    }

    .tag-title {
      vertical-align: middle;
    }

    .el-icon-close {
      width: 16px;
      height: 16px;
      line-height: 16px;
      margin-left: 4px;
      vertical-align: middle;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;

      &:hover {
        background-color: rgba(43, 47, 54, 0.18);
        color: #fff;
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fffdf8;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border: 1px solid $tagsBorder;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 0 14px 26px rgba(84, 63, 32, 0.16);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: rgba(244, 183, 64, 0.16);
        color: $navbarAccent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TagsView.vue